import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, Navigate } from 'react-router-dom';
import { useWeb3 } from './Web3Context.jsx';
import { ethers } from 'ethers';
import { VOTING_CONTRACT_ADDRESS, VOTING_CONTRACT_ABI } from './contract.js';
import VotingDashboard from './VotingDashboard.jsx';
import AdminDashboard from './AdminDashboard.jsx';

function App() {
    const { account, isSepolia, connectWallet, provider } = useWeb3();
    const [isOwner, setIsOwner] = useState(false);

    useEffect(() => {
        const checkOwner = async () => {
            if (provider && account) {
                try {
                    const contract = new ethers.Contract(VOTING_CONTRACT_ADDRESS, VOTING_CONTRACT_ABI, provider);
                    const ownerAddress = await contract.owner();
                    setIsOwner(ownerAddress.toLowerCase() === account.toLowerCase());
                } catch (error) {
                    console.error("Owner 확인 실패:", error);
                }
            } else {
                setIsOwner(false);
            }
        };
        checkOwner();
    }, [provider, account]);

    return (
        <Router>
            <div style={{ textAlign: 'center', padding: '50px', fontFamily: 'sans-serif' }}>
                <h1>탈중앙화 투표 시스템</h1>
                
                {!account ? (
                    <button onClick={connectWallet} style={{ padding: '15px 30px', fontSize: '18px', cursor: 'pointer' }}>
                        메타마스크 지갑 연결
                    </button>
                ) : (
                    <>
                        <div style={{ marginTop: '20px', padding: '20px', border: '1px solid #ddd', display: 'inline-block', width: '100%', maxWidth: '800px' }}>
                            <p><strong>연결된 지갑:</strong> {account}</p>
                            <p>
                                <strong>네트워크 상태:</strong>{' '}
                                {isSepolia ? (
                                    <span style={{ color: 'green', fontWeight: 'bold' }}>Sepolia Network 연동 완료</span>
                                ) : (
                                    <span style={{ color: 'red', fontWeight: 'bold' }}>잘못된 네트워크 (메타마스크에서 Sepolia로 변경해 주세요)</span>
                                )}
                            </p>
                        </div>
                        {isSepolia && (
                            <>
                                <nav style={{ marginTop: '20px', marginBottom: '20px' }}>
                                    <Link to="/" style={{ marginRight: '15px', fontSize: '18px', textDecoration: 'none', color: 'blue' }}>투표 대시보드</Link>
                                    {isOwner && (
                                        <Link to="/admin" style={{ fontSize: '18px', textDecoration: 'none', color: 'red' }}>관리자 페이지</Link>
                                    )}
                                </nav>
                                <Routes>
                                    <Route path="/" element={<VotingDashboard />} />
                                    <Route path="/admin" element={isOwner ? <AdminDashboard /> : <Navigate to="/" replace />} />
                                </Routes>
                            </>
                        )}
                    </>
                )}
            </div>
        </Router>
    );
}

export default App;